import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { auditDownload } from '../models/icti_icvi.model';
import { AuditorshipService } from 'src/shared/services/auditorship.service';
import { tzConvertUTC2Local } from 'src/assets/convertTimeZone/convertTimeZone';
import { Unsubscriber } from '../../unsubscriber/unsubscriber.component';
import { ErrorLibService } from 'src/shared/services/error-lib.service';
import { AuditInstallations } from '../../report-audit/models/auditInstallations.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { PaginationInfo } from '../../report-audit/models/auditList.model';
import axios from 'axios';
import { environment } from 'src/environments/environment';

// Imports Standalone

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-report-audit-download',
  templateUrl: './report-audit-download.component.html',
  styleUrls: ['./report-audit-download.component.less'],
  imports: [
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatIconModule,
    DialogModule,
    FormsModule,
    TableModule,
    ButtonModule,
    CardModule,
    FileUploadModule,
    TagModule,
    TooltipModule,
    TagModule,
    TranslateModule
  ]
})

export class ReportAuditDownloadComponent extends Unsubscriber implements OnInit {

  constructor(
    private auditorshipService: AuditorshipService,
    private errorLibService: ErrorLibService
  ) {
    super();
  }

  /** Armazena o id da empresa selecionada **/
  public company = localStorage.getItem('lastCompanySelected') ? localStorage.getItem('lastCompanySelected') : null;

  /** Propriedade que controla o loading na tela **/
  public tableIsLoading: boolean = true;

  /** Armazena a lista de relatórios de auditoria **/
  public auditDownloadList: auditDownload[] = [];

  /** Utilizado para exibir os dados da tabela na tela **/
  public dataSource = new MatTableDataSource<auditDownload>(this.auditDownloadList);

  @ViewChild(MatPaginator) paginator: MatPaginator;

  private sort: MatSort;
  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  /** Variáveis utilizadas para manipulação do Paginator **/
  public pageIndex: number = 0;
  public pageSize: number = 10;
  public lengthPage: number = 50;
  public reportsCount: number = 0;
  public previousPageIndex: number = 0;

  /** Variável utilizada para controle de paginação **/
  public paginationProperties: PaginationInfo = new PaginationInfo(
    0,
    0,
    true,
    false,
    null,
    null
  );

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    /** Realiza a requisição que traz os relatórios de icti, icvi, sdot, mprev , sdft**/
    this.getAuditReports(null);
  }

  private auditInstallationSet: AuditInstallations[] = []

  public createInstallationSet(installation: any): AuditInstallations {
    let newInstallationSet: AuditInstallations = new AuditInstallations(
      installation.installationId,
      installation.installationReference,
      installation.transmissionComplianceIndicator,
      installation.register,
      installation.status,
      installation.variables,
      installation.daytimeOperation,
      installation.nighttimeOperation,
      installation.actuation
    )
    return newInstallationSet
  }

  /**
  * Função que configura o paginator.
  */
  setDataSourceAttributes() {
    if (this.paginator && this.sort) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  /** Função que controla os botões de anterior e pŕoximo no paginator **/
  public pageChanged(event: any) {

    /** Armazena o indice da página atual **/
    const newPageIndex = event.first;

    /** Atualiza o valor da página anterior para a página atual **/
    this.previousPageIndex = this.pageIndex;

    this.pageIndex = newPageIndex;

    /** 
     * Caso o botão pressionado seja o de página anterior utiliza o
     * startCursor como cursor para o novo filtro
     * 
     * Caso o botão pressionado seja o de próxima página é utilizado
     * o endCursor como cursor
     */
    if (this.previousPageIndex > newPageIndex) {
      return this.handlePreviousPageAuditReports(this.paginationProperties.startCursor)

    } else if (this.previousPageIndex < newPageIndex) {
      return this.getAuditReports(this.paginationProperties.endCursor)
    }
  }

  /**
    * Função que busca os downloads de relatórios de auditorias existentes com paginação.
    */
  public getAuditReports(cursor: string | null): void {

    this.tableIsLoading = true;
    if (this.subscriptions) {
      //cancela subscriptions anterios 
      this.subscriptions.unsubscribe();
    }

    this.subscriptions = this.auditorshipService.getAuditReports(
      cursor,
      40,
    )
      .valueChanges
      .subscribe({
        next: (data: any) => {
          if (data.data.minasGeneratedReports.count != 0) {

            //limpa as listas depois que chegam os dados
            this.dataSource.data = [];
            this.auditDownloadList = [];

            this.paginationProperties = new PaginationInfo(
              data.data?.minasGeneratedReports?.total,
              data.data?.minasGeneratedReports?.count,
              data.data?.minasGeneratedReports?.pageInfo?.hasNextPage,
              data.data?.minasGeneratedReports?.pageInfo?.hasPreviousPage,
              data.data?.minasGeneratedReports?.pageInfo?.startCursor,
              data.data?.minasGeneratedReports?.pageInfo?.endCursor
            )

            this.lengthPage = data.data?.minasGeneratedReports?.total;
            let filteredResponse = data.data.minasGeneratedReports.edges;

            /** retorna os relatórios icvi, icti com ids iguais agrupados, onde item é o id atual procesado, e acc é o acumulador a ser retornado **/
            const groupedAuditFiles = filteredResponse.reduce((acc: any, item: any) => {
              /** armazena cada id dos relatórios **/
              const auditorshipIds = item?.node?.auditorship?.id;

              acc[auditorshipIds] = acc[auditorshipIds] || []; /// Verifica se já existe ids repetidos, caso não existir, cria um novo array vazio.
              acc[auditorshipIds].push(item); /// Adiciona o id ao acumulador
              return acc; // Retorna os ids agrupados
            }, {});

            /** Cria um set com os ids **/
            const uniqueIds = [...new Set(filteredResponse.map((item: any) => item?.node?.auditorship?.id))];

            uniqueIds.forEach((item: any) => {

              const icvi = groupedAuditFiles[item].find((reports: any) => reports?.node?.reportType === 'icvi'); // Armazena todos os relatórios do tipo icvi
              const icti = groupedAuditFiles[item].find((reports: any) => reports?.node?.reportType === 'icti'); // Armazena todos os relatórios do tipo icti
              const mprev = groupedAuditFiles[item].find((reports: any) => reports?.node?.reportType === 'mprev'); // Armazena todos os relatórios do tipo mprev
              const sdot = groupedAuditFiles[item].find((reports: any) => reports?.node?.reportType === 'sdot'); // Armazena todos os relatórios do tipo sdot

              /** Preenche a lista com os campos para popular a tabela **/
              this.auditDownloadList.push(
                new auditDownload(
                  item,
                  icti?.node?.id,
                  icvi?.node?.id,
                  sdot?.node?.id,
                  mprev?.node?.id,
                  icvi?.node?.reference ?? icti?.node?.reference ?? mprev?.node?.reference ?? sdot?.node?.reference,
                  icti?.node?.requestedBy,
                  (icvi?.node?.generationDate ?? icti?.node?.generationDate ?? mprev?.node?.generationDate ?? sdot?.node?.generationDate),
                  icti?.node?.downloadUrl,
                  icvi?.node?.downloadUrl,
                  sdot?.node?.downloadUrl,
                  mprev?.node?.downloadUrl,
                  icvi?.node?.ready
                )

              );
            });
            this.dataSource.data = this.auditDownloadList;
            this.reportsCount = this.auditDownloadList.length;
          }

          /** Desativa o loading **/
          this.tableIsLoading = false;
        },
        /** Caso ocorra algum erro **/
        error: (error: any) => {
          /** Desativa o loading na tela **/
          this.tableIsLoading = false;
          /** Exibe erro na tela **/
          this.errorLibService.errorAlert(error);
          /** Exibe o erro no console do navegador **/
          console.log(error);
        }
      });
  }

  /**
   * Função que busca as auditorias existentes com paginação . 
   * @param cursor 
   * @returns lista de auditoria anterior. 
   */
  public handlePreviousPageAuditReports(cursor: string | null): void {
    //ativa loading na tela
    this.tableIsLoading = true;

    if (this.subscriptions) {
      //cancela subscriptons anteriores 
      this.subscriptions.unsubscribe();
    }
    this.subscriptions = this.auditorshipService.handlePreviousPageAuditReports(
      cursor,
      40
    )
      .valueChanges
      .subscribe({
        next: (data: any) => {
          if (data.data.minasGeneratedReports.count != 0) {
            //limpa as listas depois que chegam os dados
            this.auditDownloadList = [];
            this.dataSource.data = [];

            this.paginationProperties = new PaginationInfo(
              data.data?.minasGeneratedReports?.total,
              data.data?.minasGeneratedReports?.count,
              data.data?.minasGeneratedReports?.pageInfo?.hasNextPage,
              data.data?.minasGeneratedReports?.pageInfo?.hasPreviousPage,
              data.data?.minasGeneratedReports?.pageInfo?.startCursor,
              data.data?.minasGeneratedReports?.pageInfo?.endCursor
            )
            this.lengthPage = data.data?.minasGeneratedReports?.total;

            /** Variável que armazena o nó de response que contém os dados que serão manipulados **/
            let filteredResponse = data.data.minasGeneratedReports.edges;

            /** retorna os relatórios icvi, icti com ids iguais agrupados, onde item é o id atual procesado, e acc é o acumulador a ser retornado **/
            const groupedAuditFiles = filteredResponse.reduce((acc: any, item: any) => {
              /** armazena cada id dos relatórios **/
              const auditorshipIds = item?.node?.auditorship?.id;

              acc[auditorshipIds] = acc[auditorshipIds] || []; /// Verifica se já existe ids repetidos, caso não existir, cria um novo array vazio.
              acc[auditorshipIds].push(item); /// Adiciona o id ao acumulador
              return acc; // Retorna os ids agrupados
            }, {});

            /** Cria um set com os ids **/
            const uniqueIds = [...new Set(filteredResponse.map((item: any) => item?.node?.auditorship?.id))];

            uniqueIds.forEach((item: any) => {

              const icvi = groupedAuditFiles[item].find((reports: any) => reports?.node?.reportType === 'icvi'); // Armazena todos os relatórios do tipo icvi
              const icti = groupedAuditFiles[item].find((reports: any) => reports?.node?.reportType === 'icti'); // Armazena todos os relatórios do tipo icti
              const mprev = groupedAuditFiles[item].find((reports: any) => reports?.node?.reportType === 'mprev'); // Armazena todos os relatórios do tipo mprev
              const sdot = groupedAuditFiles[item].find((reports: any) => reports?.node?.reportType === 'sdot'); // Armazena todos os relatórios do tipo sdot

              /** Preenche a lista com os campos para popular a tabela **/
              this.auditDownloadList.push(
                new auditDownload(
                  item,
                  icti?.node?.id,
                  icvi?.node?.id,
                  sdot?.node?.id,
                  mprev?.node?.id,
                  icvi?.node?.reference ?? icti?.node?.reference ?? mprev?.node?.reference ?? sdot?.node?.reference,
                  icti?.node?.requestedBy,
                  (icvi?.node?.generationDate ?? icti?.node?.generationDate ?? mprev?.node?.generationDate ?? sdot?.node?.generationDate),
                  icti?.node?.downloadUrl,
                  icvi?.node?.downloadUrl,
                  sdot?.node?.downloadUrl,
                  mprev?.node?.downloadUrl,
                  icvi?.node?.ready
                )

              );
            });

            this.dataSource.data = this.auditDownloadList;
            this.reportsCount = this.auditDownloadList.length;
          }

          /** Desativa o loading **/
          this.tableIsLoading = false;

        },
        /** Caso ocorra algum erro **/
        error: (error: any) => {
          /** Desativa o loading na tela **/
          this.tableIsLoading = false;
          /** Exibe erro na tela **/
          this.errorLibService.errorAlert(error);
          /** Exibe o erro no console do navegador **/
          console.log(error);
        }
      })
  }

  /**
   * Responsavél por verificar se os relatorios tem mais de 7 dias gerados
   * @param date 
   * @returns  boolean 
   */
  public isOlderFilesDownloads(date: string): boolean {

    if (!date) return false;
    const generationDate = new Date(date);
    const today = new Date();
    const diffTime = Math.abs(today.getTime() - generationDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    return diffDays > 7;
  }

  public regeneratepreSignedUrlMprev(id: any) {
    this.auditorshipService.generateMprev(this.company, id)
      .subscribe({
        next: () => {
          location.reload();
        },
        error: (error: any) => {
          console.log(error.message);
          this.errorLibService.errorAlert(error);
        }
      })
  }

  public regeneratepreSignedUrlIcti(id: any) {

    this.auditorshipService.generateIcti(this.company, id)
      .subscribe({
        next: () => {
          location.reload();
        },
        error: (error: any) => {
          console.log(error.message);
          this.errorLibService.errorAlert(error);
        }
      })
  }

  public regeneratepreSignedUrlIcvi(id: any) {
    this.auditorshipService.generateIcvi(this.company, id)
      .subscribe({
        next: () => {
          location.reload();
        },
        error: (error: any) => {
          console.log(error.message);
          this.errorLibService.errorAlert(error);
        }
      })
  }

  public regeneratepreSignedUrlSdot(id: any) {
    this.auditorshipService.generateSdot(this.company, id)
      .subscribe({
        next: () => {
          location.reload();
        },
        error: (error: any) => {
          console.log(error.message);
          this.errorLibService.errorAlert(error);
        }
      })
  }

  public getAuditorshipInstallations(id: any) {
    this.subscriptions = this.auditorshipService.getAuditorshipInstallations(id)
      .valueChanges
      .subscribe({
        next: (auditData: any) => {
          let auditPayload = auditData.data.auditorship.edges[0].node;
          let auditInstallationSet = auditPayload.installationauditSet.edges;
          auditInstallationSet.forEach((installation: any) => {
            this.auditInstallationSet.push(
              this.createInstallationSet(installation.node)
            );
          });

          this.auditorshipService.downloadCsv(this.auditInstallationSet);
          this.auditInstallationSet = [];
        }
      })
  }

  public downloadReportAudit(referenceAudit: any): void {

    try {
      let reportLink: string = environment.bifrostUrl.replace('/graphql/', referenceAudit);

      const token = localStorage.getItem('token')

      // configura o header da requisição
      const headers = {
        'Accept': '*/*',
        'Authorization': `Bearer ${token}`
      };

      axios.get(reportLink, { headers, responseType: 'blob' })
        .then((response: any) => {
          const blob = new Blob([response?.data], { type: response?.headers['content-type'] || 'application/octet-stream' });

          const objectUrl = URL.createObjectURL(blob);

          const a = document.createElement('a');

          a.style.display = 'none';
          a.href = objectUrl;
          a.download = referenceAudit.split('/').pop();

          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        });

    } catch (error) {
      console.log("Erro ao realizar download do relatorio:", error);
      this.errorLibService.errorAlert(error);
    }

  }



}
